import { apiClient } from './client';

export function getCloneEligibility (shopId: number | string) {
  return apiClient.get(`/destination-shop/${shopId}/clone-eligibility`);
}

export function getClones (shopId: number | string) {
  return apiClient.get(`/destination-shop/${shopId}/clone`);
}

export function cloneShop (shopId: number | string, payload: Record<string, unknown>) {
  return apiClient.post(`/destination-shop/${shopId}/clone`, payload);
}

export function revertClone (shopId: number | string, cloneId: number | string) {
  return apiClient.post(`/destination-shop/${shopId}/clone/${cloneId}/revert`);
}
